import { PriceFormatterPipe } from './utils/priceFormatter.pipe';
import { Utils } from './utils/utils';
import { DynamicComponent } from './components/dynamic/dynamic.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { TooltipDirective } from './directives/tooltip.directive';
import { TooltipService } from './services/tooltip.service';
import { NewrelicService } from './services/newrelic/newrelic.service';
import { UpaService } from './services/upa/upa.service';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CurrencyFilterComponent } from './components/currency-filter/currency-filter.component';
import { NewRelicErrorHandler } from './utils/newRelicErrorHandler';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TabFilterComponent } from './components/tab-filter/tab-filter.component';
import { TransferClusterComponent } from './components/transfer-cluster/transfer-cluster.component';
import { TransferMarqueeComponent } from './components/transfer-marquee/transfer-marquee.component';
import { ClusterPriceboxComponent } from './components/cluster-pricebox/cluster-pricebox.component';
import { TransferFilterPipe } from './utils/transfer-filter-pipe/transfer-filter.pipe';
import { TransfersMapComponent } from './components/transfers-map/transfers-map.component';
import { MapComponent } from './components/map/map.component';
import { ResultsComponent } from './components/results/results.component';
import { ClusterAmenitiesComponent } from './components/cluster-amenities/cluster-amenities.component';
import { I18nPluralPipe, LowerCasePipe } from '@angular/common';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { TransferSearchboxComponent } from './components/transfer-searchbox/transfer-searchbox.component';
import { BannerComponent } from './components/banner/banner.component';
import { PeggyBannerComponent } from './components/peggy-banner/peggy-banner.component';
import { StaticMapComponent } from './components/static-map/static-map.component';
import { ModalComponent } from './components/modal/modal.component';
import { MapModalComponent } from './components/modal/map-modal/map-modal.component';
import { CloseModalClick } from './components/modal/modal.directive';
import { ModalService } from './services/modal/modal.service';
import { CurrencyModalComponent } from './components/modal/currency-modal/currency-modal.component';
import { StaticValuesUtils } from './utils/static-values/static-values.utils';
import { LoyaltyModule, LoyaltyService } from '@shopping-angular-components/loyalty';
import {SanitizedHtmlPipe} from "./utils/sanitizedHtml.pipe";
import {ModalModule} from "@shopping-angular-components/modal";
import { ClickStopPropagationDirective } from './directives/click-stop-propagation.directive';
import {AbTestService} from "./services/abTest.service";
import { ReasonsToBuyBannerComponent } from './components/reasons-to-buy-banner/reasons-to-buy-banner.component';
import {RatingModule} from "@shopping-angular-components/rating";

import { CalculationTextPipe } from './pipes/calculations-text.pipe';
import { AgencyRevenueRibbonModule } from '@shopping-angular-components/agency-revenue-ribbon';
import { SearchboxV2Module } from '@shopping-angular-components/searchbox-v2';
import { MessageComponent } from './shared/message/message.component';
import { FavoriteManagerModule } from './shared/favorite-manager/favorite-manager.module';
import { PromotionLabelComponent } from './components/promotion-label/promotion-label.component';
import { CouponCoachmarkComponent } from './components/coupon-coachmark/coupon-coachmark.component';
import { CartManagerComponent } from './shared/cart-manager/cart-manager.component';
import { PriceDetailModalComponent } from './components/modal/price-detail-modal/price-detail-modal.component';

import { DualCurrencyModalModule } from '@shopping-angular-components/dual-currency-modal';
import { DualCurrencyModalWrapperComponent } from './components/modal/dual-currency-modal-wrapper/dual-currency-modal-wrapper.component';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  // empty suffix because our global i18nFiles var already has .json
  // example: es_AR.9790b93ed555e59152ceaaa13cfb6046.json
  return new TranslateHttpLoader(http, StaticValuesUtils.getStaticUrl() + '/assets/i18n/', '');
}

@NgModule({
  declarations: [
    AppComponent,
    ResultsComponent,
    TransferClusterComponent,
    TabFilterComponent,
    CurrencyFilterComponent,
    ResultsComponent,
    TransferMarqueeComponent,
    ClusterPriceboxComponent,
    ClusterAmenitiesComponent,
    TransferFilterPipe,
    EmptyStateComponent,
    TransferSearchboxComponent,
    TransferFilterPipe,
    TransfersMapComponent,
    MapComponent,    
    BannerComponent,
    PeggyBannerComponent,
    StaticMapComponent,
    ModalComponent,
    MapModalComponent,
    CloseModalClick,
    CurrencyModalComponent,
    TooltipDirective,
    TooltipComponent,
    DynamicComponent,
    PriceFormatterPipe,
    SanitizedHtmlPipe,
    ClickStopPropagationDirective,
    ReasonsToBuyBannerComponent,
    CalculationTextPipe,
    MessageComponent,
    PromotionLabelComponent,
    CouponCoachmarkComponent,
    CartManagerComponent,
    PriceDetailModalComponent,
    DualCurrencyModalWrapperComponent
  ],
  exports: [
    PriceFormatterPipe,
    SanitizedHtmlPipe,
    CalculationTextPipe
  ],
    imports: [
        BrowserModule,
        FormsModule,
        AppRoutingModule,
        HttpClientModule,
        LoyaltyModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        ModalModule,
        RatingModule,
        AgencyRevenueRibbonModule,
        SearchboxV2Module,
        FavoriteManagerModule,
        DualCurrencyModalModule
    ],
  providers: [
    {provide: ErrorHandler, useClass: NewRelicErrorHandler},
    I18nPluralPipe,
    LowerCasePipe,
    ModalService,
    TooltipService,
    UpaService,
    NewrelicService,
    AbTestService,
    Utils,
    LoyaltyService
  ],
  entryComponents: [
    TooltipComponent
  ],
  bootstrap: [
    AppComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AppModule { }
